import { useState, useCallback, useEffect } from 'react';
import {
	getFormFieldDataBackup,
	clearFormFieldDataBackup,
	FormFieldDataBackup
} from '../../utils/formBackupUtils';
import {
	UseRestoreBackupModalReturn,
	UseRestoreBackupModalOptions
} from './RestoreBackupModal.types';

export const useRestoreBackupModal = ({
	formID,
	loadingCancel,
	onRestore
}: UseRestoreBackupModalOptions): UseRestoreBackupModalReturn => {
	const [showRestoreModal, setShowRestoreModal] = useState<boolean>(false);
	const [backupData, setBackupData] = useState<FormFieldDataBackup | null>(null);
	const [formKey, setFormKey] = useState<number>(0);

	// Check for backup when formID is available and loading is complete
	useEffect(() => {
		if (!formID || loadingCancel) return;

		const backup = getFormFieldDataBackup(formID);
		if (backup?.fieldData && backup.fieldData.length > 0) {
			setBackupData(backup);
			setShowRestoreModal(true);
		}
	}, [formID, loadingCancel]);

	const handleRestoreBackup = useCallback((): void => {
		if (backupData?.fieldData) {
			onRestore(backupData.fieldData);
			// Increment key to force form remount
			setFormKey((prev) => prev + 1);
		}
		setShowRestoreModal(false);
		setBackupData(null);
	}, [backupData, onRestore]);

	const handleDeleteBackup = useCallback((): void => {
		if (formID) {
			clearFormFieldDataBackup(formID);
		}
		setShowRestoreModal(false);
		setBackupData(null);
	}, [formID]);

	return {
		showRestoreModal,
		backupData,
		handleRestoreBackup,
		handleDeleteBackup,
		formKey
	};
};
